// extracted by mini-css-extract-plugin
export default {"group":"group___wvq3E"};